export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 15.4954b5e0.jpeg";